import { AxiosError } from 'axios';
import { put, call, takeLatest } from 'redux-saga/effects';
import { API } from '../api/base';
import { types, Country } from './types';

import { getErrorMessage } from 'services/api/normalizer';

export function* getCountriesAsync() {
  const countriesApi = new API(`countries`);
  yield put({ type: types.GET_COUNTRIES_ASYNC.PENDING, payload: true });

  try {
    const response: Country[] = yield call(countriesApi.getAll);
    yield put({ type: types.GET_COUNTRIES_ASYNC.SUCCESS, payload: response });
  } catch (err) {
    const message = getErrorMessage(err as AxiosError) || 'There was a problem while fetching countries list';

    yield put({ type: types.GET_COUNTRIES_ASYNC.ERROR, payload: message });
  } finally {
    yield put({ type: types.GET_COUNTRIES_ASYNC.PENDING, payload: false });
  }
}

export const sagas = [takeLatest(types.GET_COUNTRIES_ASYNC.REQUEST, getCountriesAsync)];
